import React, { useState } from 'react';
import bgImage from '../../../assets/images/bg_img.svg';
import aboutImage from '../../../assets/images/inner_design_heading.svg';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import FaqPageHelmet from '../../HelmetComponents/FaqPageHelmet';

const FAQPage: React.FC = () => {
  // useDocumentTitle('Namasteji Manikchand - FAQ');
  const faqs = [
    {
      question: 'What is Namasteji Manikchand?',
      answer:
        'Namasteji Manikchand is a premium-quality product available online for convenient purchase and home delivery.',
    },
    {
      question: 'How can I place an order?',
      answer: 'Visit the product page, select your preferred pack, add it to your cart, and proceed to checkout.',
    },
    {
      question: 'Are there different pack sizes available?',
      answer: 'Yes, Namasteji Manikchand is available in multiple sizes to suit your needs.',
    },
    {
      question: 'Do I need to create an account to place an order?',
      answer:
        "While it's not mandatory, creating an account helps you track your orders, manage your details, and earn reward points.",
    },
    {
      question: 'What are reward points and how do they work?',
      answer:
        'You earn reward points with every purchase. These points can be redeemed for discounts or special offers in future orders.',
    },
    {
      question: 'Is there any shipping charge?',
      answer: 'No, we offer free doorstep delivery on all orders.',
    },
    {
      question: 'How long will it take to receive my order?',
      answer: 'Delivery times may vary by location, but we aim for fast and timely dispatch.',
    },
    {
      question: 'Can I return or exchange the product?',
      answer:
        'Returns or exchanges are accepted only for damaged or incorrect deliveries. Please reach out within 24 hours of receiving the product.',
    },
    {
      question: 'Is the product hygienic?',
      answer: 'Yes, all Namasteji Manikchand products go through strict quality checks before shipping.',
    },
    {
      question: 'Can I buy Namasteji Manikchand in bulk?',
      answer: 'Yes, you can select multiple packs when placing your order.',
    },
  ];

  const faqsOrdersDeliveryPayments = [
    {
      question: 'How can I track my order?',
      answer: 'After placing your order, you’ll receive a tracking link via SMS or email.',
    },
    {
      question: 'What payment options are available?',
      answer: 'We accept UPI, net banking, credit/debit cards, and other secure payment modes.',
    },
    {
      question: 'Are my payment details safe?',
      answer: 'Yes, all transactions are encrypted and processed through secure gateways.',
    },
    {
      question: 'What should I do if my order is delayed?',
      answer: 'If your order is delayed beyond the expected time, please contact our support team for updates.',
    },
    {
      question: 'Can I change my delivery address after placing the order?',
      answer:
        "Please contact us immediately after ordering. If the package hasn't been dispatched, we’ll update the delivery address.",
    },
  ];

  const faqsAccountSupport = [
    {
      question: 'How can I create an account?',
      answer: 'Click on the “Sign Up” button and fill in your basic details to get started.',
    },
    {
      question: 'How do I reset my password?',
      answer: 'Click “Forgot Password” on the login page and follow the steps to reset it.',
    },
    {
      question: 'How can I view my order history?',
      answer: 'Log in to your account and navigate to “My Orders” to view past purchases.',
    },
    {
      question: 'What if I don’t receive my order?',
      answer: 'In rare cases of non-delivery, contact our support team and we’ll investigate and resolve it promptly.',
    },
    {
      question: 'How do I reach the Namasteji Manikchand support team?',
      answer: 'Click the “Contact Us” button on the website or reach out via email or phone for assistance.',
    },
  ];

  const faqsRewardPointsPartnerApp = [
    {
      question: 'Do I have to buy from the Namasteji Manikchand – Partner App to get reward points?',
      answer: "No, it's not mandatory. You can purchase the product from any store or source.",
    },
    {
      question: 'How can I claim reward points if I didn’t buy through the app?',
      answer:
        'Simply download the Namasteji Manikchand – Partner App from the Play Store, log in, and scan the QR code on your product pack.',
    },
    {
      question: 'Is scanning the QR code necessary to get reward points?',
      answer: 'Yes, reward points are only credited after scanning the QR code via the Partner App.',
    },
    {
      question: 'Can I scan the QR code without logging in to the app?',
      answer: 'No, you must be logged in to your account in the Partner App to earn points.',
    },
    {
      question: 'If the loyalty program expires, can I use my old points in the next program?',
      answer:
        "No, reward points earned during a specific loyalty program are valid only for that program's duration. Once the loyalty program expires, unused or unredeemed points will be forfeited and cannot be carried forward or used in the next loyalty cycle.",
    },
    {
      question: 'What if I forget to scan my product? Will I lose the points?',
      answer:
        'Yes, if you don’t scan before the loyalty offer period ends, the reward points will expire and cannot be claimed later.',
    },
    {
      question: 'Can I scan multiple packs in one go?',
      answer: 'Yes, you can scan multiple packs, but each QR code can only be scanned once.',
    },
    {
      question: 'Can I earn points for past purchases?',
      answer:
        'Only if the QR code is still intact and the loyalty offer is still active. Expired or used codes won’t be valid.',
    },
    {
      question: 'Do I need internet access to scan and earn points?',
      answer: 'Yes, the app requires an active internet connection to process your scan and credit the points.',
    },
    {
      question: 'Where can I check my total reward points?',
      answer:
        'Open the Partner App, log in, and go to the Rewards or Points Wallet section to view your earned points.',
    },
  ];

  /** First item open by default */
  const [openIndex, setOpenIndex] = useState(0);
  const [openIndexOrdersDeliveryPayments, setOpenIndexOrdersDeliveryPayments] = useState(0);
  const [openIndexAccountSupport, setOpenIndexAccountSupport] = useState(0);
  const [openIndexRewardPointsPartnerApp, setOpenIndexRewardPointsPartnerApp] = useState(0);

  const toggleIndex = (index: any) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const toggleIndexOrdersDeliveryPayments = (index: any) => {
    setOpenIndexOrdersDeliveryPayments(index === openIndexOrdersDeliveryPayments ? null : index);
  };

  const toggleIndexAccountSupport = (index: any) => {
    setOpenIndexAccountSupport(index === openIndexAccountSupport ? null : index);
  };

  const toggleIndexRewardPointsPartnerApp = (index: any) => {
    setOpenIndexRewardPointsPartnerApp(index === openIndexRewardPointsPartnerApp ? null : index);
  };

  return (
    <>
      <FaqPageHelmet />
      <section className='w-full'>
        <div
          className='relative flex flex-col items-center justify-center h-[300px] sm:h-[300px] md:h-[600px] text-center'
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <h1 className='text-[#4A2D1A] font-rubik text-[28px] sm:text-[28px] md:text-[32px] lg:text-[32px] font-bold relative md:mt-4 lg:mt-4 drop-shadow-[0_2px_2px_rgba(0,0,0,0.7)]'>
            FAQ
          </h1>
          <div className='flex justify-center mt-4 w-full px-4'>
            <img src={aboutImage} alt='FAQ Manikchand' className='max-w-full h-auto' />
          </div>
        </div>

        {/* --- Orders, Delivery & Payments --- */}
        <section className='py-4 sm:py-4 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-white'>
          <div className='max-w-6xl mx-auto bg-white bg-opacity-90 rounded-lg'>
            {/* <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl font-bold text-[#4A2D1A] mt-6 sm:mt-6 md:mt-0 lg:mt-0  mb-4 md:mb-6 lg:mb-6 sm:mb-6">
            FREQUENTLY ASKED QUESTIONS
          </h2> */}
            <div className='space-y-4 text-justify'>
              {faqs.map((faq, index) => (
                <div key={index} className='rounded-lg overflow-hidden'>
                  <button
                    onClick={() => toggleIndex(index)}
                    className='w-full flex justify-between bg-[#ECE0BD] text-[#2B2B2B] font-poppins text-sm sm:text-sm md:text-base base:text-lg px-4 py-4 font-semibold hover:bg-[#D9C398] transition text-justify'
                  >
                    <span>{faq.question}</span>
                    <span className='text-2xl leading-none pl-4'>
                      {openIndex === index ? (
                        <FaChevronDown className='text-[#2B2B2B] h-4 w-4 object-contain transition-transform duration-300' />
                      ) : (
                        <FaChevronUp className='text-[#2B2B2B] h-4 w-4 object-contain transition-transform duration-300' />
                      )}
                    </span>
                  </button>

                  {openIndex === index && faq.answer && (
                    <div className='bg-[#ECE0BD80] text-[#000000] font-poppins text-sm sm:text-sm md:text-base base:text-lg px-4 py-3'>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className='max-w-6xl mx-auto bg-white bg-opacity-90 rounded-lg'>
            <h2 className='text-base sm:text-base md:text-2xl lg:text-2xl font-bold text-[#4A2D1A]  my-4 md:my-6 lg:my-6 sm:my-6 text-start'>
              Orders, Delivery & Payments
            </h2>
            <div className='space-y-4 text-justify'>
              {faqsOrdersDeliveryPayments.map((faq, index) => (
                <div key={index} className='rounded-lg overflow-hidden'>
                  <button
                    onClick={() => toggleIndexOrdersDeliveryPayments(index)}
                    className='w-full flex justify-between bg-[#ECE0BD] text-[#2B2B2B] font-poppins text-sm sm:text-sm md:text-base base:text-lg px-4 py-4 font-semibold hover:bg-[#D9C398] transition text-justify'
                  >
                    <span>{faq.question}</span>
                    <span className='text-2xl leading-none pl-4'>
                      {openIndexOrdersDeliveryPayments === index ? (
                        <FaChevronDown className='text-[#2B2B2B] h-4 w-4 object-contain transition-transform duration-300' />
                      ) : (
                        <FaChevronUp className='text-[#2B2B2B] h-4 w-4 object-contain transition-transform duration-300' />
                      )}
                    </span>
                  </button>

                  {openIndexOrdersDeliveryPayments === index && faq.answer && (
                    <div className='bg-[#ECE0BD80] text-[#000000] font-poppins text-sm sm:text-sm md:text-base base:text-lg px-4 py-3'>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          {/*  Account & Support */}
          <div className='max-w-6xl mx-auto bg-white bg-opacity-90 rounded-lg'>
            <h2 className='text-base sm:text-base md:text-2xl lg:text-2xl font-bold text-[#4A2D1A]  my-4 md:my-6 lg:my-6 sm:my-6 text-start'>
              Account & Support
            </h2>
            <div className='space-y-4 text-justify'>
              {faqsAccountSupport.map((faq, index) => (
                <div key={index} className='rounded-lg overflow-hidden'>
                  <button
                    onClick={() => toggleIndexAccountSupport(index)}
                    className='w-full flex justify-between bg-[#ECE0BD] text-[#2B2B2B] font-poppins text-sm sm:text-sm md:text-base base:text-lg px-4 py-4 font-semibold hover:bg-[#D9C398] transition text-justify'
                  >
                    <span>{faq.question}</span>
                    <span className='text-2xl leading-none pl-4'>
                      {openIndexAccountSupport === index ? (
                        <FaChevronDown className='text-[#2B2B2B] h-4 w-4 object-contain transition-transform duration-300' />
                      ) : (
                        <FaChevronUp className='text-[#2B2B2B] h-4 w-4 object-contain transition-transform duration-300' />
                      )}
                    </span>
                  </button>

                  {openIndexAccountSupport === index && faq.answer && (
                    <div className='bg-[#ECE0BD80] text-[#000000] font-poppins text-sm sm:text-sm md:text-base base:text-lg px-4 py-3'>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Reward Points & Partner App – FAQs */}
          <div className='max-w-6xl mx-auto bg-white bg-opacity-90 rounded-lg'>
            <h2 className='text-base sm:text-base md:text-2xl lg:text-2xl font-bold text-[#4A2D1A]  my-4 md:my-6 lg:my-6 sm:my-6 text-start'>
              Reward Points & Partner App – FAQs
            </h2>
            <div className='space-y-4 text-justify'>
              {faqsRewardPointsPartnerApp.map((faq, index) => (
                <div key={index} className='rounded-lg overflow-hidden'>
                  <button
                    onClick={() => toggleIndexRewardPointsPartnerApp(index)}
                    className='w-full flex justify-between bg-[#ECE0BD] text-[#2B2B2B] font-poppins text-sm sm:text-sm md:text-base base:text-lg px-4 py-4 font-semibold hover:bg-[#D9C398] transition text-justify'
                  >
                    <span>{faq.question}</span>
                    <span className='text-2xl leading-none pl-4'>
                      {openIndexRewardPointsPartnerApp === index ? (
                        <FaChevronDown className='text-[#2B2B2B] h-4 w-4 object-contain transition-transform duration-300' />
                      ) : (
                        <FaChevronUp className='text-[#2B2B2B] h-4 w-4 object-contain transition-transform duration-300' />
                      )}
                    </span>
                  </button>

                  {openIndexRewardPointsPartnerApp === index && faq.answer && (
                    <div className='bg-[#ECE0BD80] text-[#000000] font-poppins text-sm sm:text-sm md:text-base base:text-lg px-4 py-3'>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </section>
    </>
  );
};
export default FAQPage;
